"use client";

import { Open_Sans } from "next/font/google";
import { createTheme } from "@mui/material/styles";

const openSans = Open_Sans({
  weight: ["300", "400", "500", "700"],
  subsets: ["latin"],
  display: "swap",
});

const theme = createTheme({
  // direction: "rtl",
  palette: {
    mode: "light",
    primary: {
      main: "#73A6B7",
    },
    secondary: {
      main: "#FFFFFF",
    },
    background: {
      default: "#FCFCFC",
    },
    common: {
      white: "#FFFFFF",
    },
    text: {
      primary: "#43321E",
      secondary: "#171717",
    },
  },
  typography: {
    fontFamily: openSans.style.fontFamily,
  },
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          margin: 0,
          boxShadow: "none", // Removes default shadow
          border: "none", // Optional: add a border
          "&:before": {
            display: "none", // Removes the default divider line
          },
          "&.Mui-expanded": {
            margin: 0,
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          fontSize: 22,
          fontWeight: 600,
          minHeight: 0,
          "&.Mui-expanded": {
            minHeight: 0,
          },
        },
        content: {
          margin: 0,
          "&.Mui-expanded": {
            margin: 0,
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            paddingRight: "9px !important",
          },
          "& .MuiAutocomplete-endAdornment": {
            left: "9px !important",
            right: "unset !important",
          },
          "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
            marginRight: "-4px",
            marginLeft: "4px",
          },
        },
      },
    },
  },
});

export default theme;
